// extracted by mini-css-extract-plugin
module.exports = {"dialogButton":"Dialog_dialogButton__3Q0_g","overlay":"Dialog_overlay__2b2rm","message":"Dialog_message__ACkQ9"};